import { Button, Group } from '@mantine/core';
import classes from './PianoKeyboard.module.css';

const NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export function PianoKeyboard({
  lowMidi, highMidi, onKey,
}: { lowMidi: number; highMidi: number; onKey: (midi: number) => void }) {
  const keys: number[] = [];
  for (let m = lowMidi; m <= highMidi; m++) keys.push(m);
  return (
    <Group gap={2} justify="center" wrap="nowrap" className={classes.keyboard}>
      {keys.map((m) => {
        const name = NAMES[m % 12];
        const isBlack = name.includes('#');
        return (
          <Button
            key={m}
            size="xs"
            variant={isBlack ? 'filled' : 'default'}
            color={isBlack ? 'dark' : undefined}
            className={isBlack ? classes.black : classes.white}
            onClick={() => onKey(m)}
            aria-label={`${name}${Math.floor(m / 12) - 1}`}
          >
            {name}
          </Button>
        );
      })}
    </Group>
  );
}
